var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasksViewEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fee471;}.cls-2{fill:#784ace;}.cls-3{fill:#00dbd5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.09,
    y: 77.81,
    width: 433.21,
    height: 521.26,
    rx: 22.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.21,
    y: 321.46,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(2.66 -2.23) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.26,
    y: 445.09,
    width: 296.03,
    height: 61.81,
    rx: 30.91,
    transform: "translate(3.58 -2.22) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.15,
    y: 197.83,
    width: 295.17,
    height: 61.81,
    rx: 30.91,
    transform: "translate(1.73 -2.24) rotate(0.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.69,
    y: 49.32,
    width: 192.02,
    height: 62.01,
    rx: 31.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.5,30.1a20.23,20.23,0,1,1-20.22,20.22A20.24,20.24,0,0,1,300.5,30.1m0-30a50.23,50.23,0,1,0,50.22,50.22A50.23,50.23,0,0,0,300.5.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksViewEntries);
export default __webpack_public_path__ + "static/media/tasks_view_entries.3152552dbd12e9874cdaa1f49d07b86b.svg";
export { ForwardRef as ReactComponent };